<template>
<div>
            <div class="edit-step">
            <steps :active = "1"></steps>
        </div>
    <div id="editHelp" class="app-inner">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit('ruleForm')"
            >
                下一步
           </el-button>
            </div>
         <!-- <div class="edit-header flex align-cen">
            <el-button plain @click="reback">返回</el-button>
             <el-button type="primary" class="mft" @click="onSubmit('ruleForm')">下一步</el-button>
        </div> -->
         <div class="edit-from">
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
            <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                 <el-form-item label="帮助课程名称：" prop="title">
                    <el-input v-model="form.title" placeholder="请输入帮助课程名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="选择关联应用：" prop="appId">
                     <el-checkbox-group v-model="checkList" @change="classSelectType">
                  <el-checkbox label="1">和隆优化官网</el-checkbox>
                  <el-checkbox label="2">和隆软件官网</el-checkbox>
              </el-checkbox-group>
                    <el-select v-model="form.appId" placeholder="选择关联应用：">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.appName === '未分类' ? '未分类' : item.appName"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="课程封面：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :disabled="uploadBoolean"
                    :before-upload="$util.beforeUpload"
                    :on-error="upLoaderror"
                    >
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                     <div @click.stop="uploadPicture('flagImg')" class="uploadPicture"  v-if="form.logo" >点击裁剪</div>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    <div>建议大小：371*130px 最大限制5M，支持JPG，PNG格式上传</div>
                 </el-form-item>
                  <el-form-item label="帮助排序：">
                    <el-input v-model="form.sort" placeholder="请输入帮助排序" clearable></el-input>
                </el-form-item>
            </el-form>
              <el-dialog
        title="裁切封面"
        :visible.sync="cropperModel"
        width="950px"
        center
        :modal-append-to-body="false"
        v-if="cropperModel"
       >
     <cropper-image
         :Name="cropperName"
         :Logo="form.logo"
         @uploadImgSuccess = "handleUploadSuccess"
         ref="child">
     </cropper-image>
    </el-dialog>
         </div>
    </div>
    </div>
</template>
<script>
import steps from "@/components/steps/index.vue"; //步骤条组件
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import {edithelpStatus,helpDetail,helpAppList} from "@/api/index/index"  //帮助基本信息修改接口、帮助基本信息详情 、应用分类
import CropperImage from "@/components/CropperImage.vue";  //裁剪组件

export default {
    name:'editHelpInfo',
    components: {
        steps,
        CropperImage
    },
    data: () =>{
        return {
            checkList:[],
            loading:false,
            cropperModel:false,
            cropperName:'',
            edittext:'保存',
              headers:{},
                uploadBoolean:false,
                oploadDialogVisible: false,
            rules:{
             title: [{ required: true, message: '请输入帮助课程名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
             ],
             appId: [{ required: true, message: '请选择关联应用', trigger: 'change' },],
             logo: [{ required: true, message: '请上传课程封面', trigger: 'blur' }],
            },
            form:{
               title:'',
               appId:'',
               logo:'',
               sort:'' 
            },
            options:[]
        }
    },
    created(){
        let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id){
            this.$route.meta.title = "修改帮助信息"
           this.getDetail()
        }else{
            this.$route.meta.title = "新增帮助" 
        }
    },
    methods: {
           classSelectType(){
           let checkStr = this.checkList.join(',')
           let num = ['1,2', '2,1'].includes(checkStr);
              let officialType = ''
               num ? officialType = "" : officialType = checkStr
               num ? officialType = "" : officialType = checkStr
              this.getApplist(officialType)
      }, 
        // 获取应用
        getApplist(num){
            helpAppList({
            officialType:num
              })
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
        // 图片裁剪
        uploadPicture(name){
            this.cropperName = name;
            this.cropperModel = true;
            },
             //裁剪图片上传成功后
    handleUploadSuccess (data){
       this.form.logo = data.url;
      this.cropperModel = false;
    },
         // 获取详情
        getDetail(){
              helpDetail({
                id:this.$route.query.id
              })
            .then(res => {
                this.form = {
                    title:res.data.title,
                    appId:res.data.appId,
                    logo:res.data.logo,
                    sort:res.data.sort
                }
                      let num = ['1,2', '2,1'].includes(res.data.officialType);
              let officialType = ''
               num ? officialType = "" : officialType = res.data.officialType
               num ? officialType = "" : officialType = res.data.officialType
              this.getApplist(officialType)
              this.checkList = res.data.officialType.split(',')
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
              this.$confirm('需要返回至上一级吗？系统可能不会保存您所做的更改。', '返回提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.$router.push("/helpList")
                        }).catch(() => {          
                        });
        },
         // 图片放大
         oploadImgPre(){
                this.oploadDialogVisible = true
            },
             oploadImgDel(){
                this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.logo){
        this.uploadBoolean = true
         }
         console.log(this.form.logo)
      },
    //   图片上传失败钩子
        upLoaderror(err){
            this.$message.error('图片上传失败')
        },
        onSubmit(formName){
                let params = { ...this.form};
                    let method = "post"
                     if(!this.$route.query.id) params = {...this.form},method = "post"; 
                     if(this.$route.query.id) params = {...this.form,id:this.$route.query.id,state:this.$route.query.state}, method = "put"; 
                    this.$refs[formName].validate((valid) => {
                        if(valid){
                            this.commentBness(params,method)
                }
            })
        },
         commentBness(params,method){
             this.loading = true
                edithelpStatus(params,method)
                        .then(res => {
                             this.loading = false
                           if(res.code == 0){
                            if(this.$route.query.id){
                             let data = {
                                row:{
                                    id:this.$route.query.id,
                                    state:'0',
                                    sedittype:true
                                }
                            }
                            this.$bus.$emit("state",data);
                            }
                              this.$router.push({
                                name: "helpChapter",
                                query:{
                                    id:this.$route.query.id ? this.$route.query.id : res.data,
                                    state:this.$route.query.state,
                                }
                            })
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                            this.loading = false
            })
        },
    }
}
</script>
<style lang="scss" scoped>
#editHelp{
    position: relative;
    .posta{
        width: calc(100% - 240px);
        position: absolute;
        background-color: rgb(255, 255, 255);
    box-shadow: rgb(240 240 240) 1px -2px 8px;
    height: 60px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: fixed;
    left: 240px;
    bottom: 60px;
    z-index: 6;
    padding-left: 0;
    }
    .edit-header{
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;

    }
      .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        }
         }
         }
}
  ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>